import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App.js";
import {
  ErrorBoundary,
  AppRootFallback,
} from "./components/ErrorBoundary.js";

// Register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("SW registration failed:", err));
  });
}

const root = document.getElementById("root");
if (!root) throw new Error("No #root element");
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary
      name="AppRoot"
      fallback={(error, reset) => (
        <AppRootFallback error={error} onReset={reset} />
      )}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
